<template>
  <button
    class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
    role="menuitem"
    @click="createOffer"
  >
    {{ account.name }}
  </button>
</template>

<script>
export default {
  props: {
    agency: {
      type: Object,
      required: true,
    },
  },
  computed: {
    account() {
      return this.$store.state.entities.accounts.byId[this.agency.account_uuid];
    },
  },
  methods: {
    createOffer() {
      this.$emit('create-offer', {
        accountId: this.account.id,
        defaultFormData: {
          accountRelationUuid: this.agency.uuid,
        },
      });
    },
  },
};
</script>
